module.exports = __webpack_public_path__ + "img/text-cta.cf0ea5d8.svg";